// SortSelect.tsx
"use client";

import { Select, SelectProps } from "modules/common/components/ui/Select";
import { BaseSortOption, ReadonlySortOption } from "./types";
import { cn } from "utils/utils";

interface SortSelectProps<T extends BaseSortOption | ReadonlySortOption<any>>
  extends Pick<SelectProps, "variant" | "color" | "size"> {
  options: readonly T[] | T[];
  currentIndex: number;
  onChange: (index: number) => void;
  className?: string;
}

export function SortSelect<T extends BaseSortOption | ReadonlySortOption<any>>({
  options,
  currentIndex,
  onChange,
  className,
  variant,
  color,
  size,
}: SortSelectProps<T>) {
  return (
    <Select
      name="sort"
      layout="horizontal"
      options={options.map((option, idx) => ({
        value: idx,
        label: option.name,
      }))}
      value={currentIndex}
      onChange={(value) => onChange(Number(value))}
      label="Sort by"
      className={cn(className)}
      variant={variant}
      color={color}
      size={size}
    />
  );
}
